import domReady from "@wordpress/dom-ready";
import YouTubePlayer from "youtube-player";
import VimeoPlayer from "@vimeo/player";

let players = [];
domReady(() => {
	const allYoutubePlayers = document.querySelectorAll(".youtube-player");

	allYoutubePlayers?.forEach((youtubePlayerElem) => {
		const elemId = youtubePlayerElem.getAttribute("id");
		const videoID = youtubePlayerElem.getAttribute("data-video-id");
		players[elemId] = YouTubePlayer(elemId, {
			width: "1400",
			height: "788",
			videoId: videoID,
		});
		// player.loadVideoById(videoID);
		// player.playVideo();
	});

	const allVimeoPlayers = document.querySelectorAll(".vimeo-player");

	allVimeoPlayers?.forEach((vimeoPlayerElem) => {
		const elemId = vimeoPlayerElem.getAttribute("id");
		const videoID = vimeoPlayerElem.getAttribute("data-video-id");
		players[elemId] = new VimeoPlayer(elemId, {
			id: videoID,
			width: 1400,
			height: "auto",
			maxHeight: "100%",
		});
		// player.setVolume(0);
		// player.play();
	});

	const allOverlays = document.querySelectorAll(
		".wp-block-zebra-blocks-full-media .overlay"
	);
	allOverlays?.forEach((overlay) => {
		const thisSection = overlay.closest("section");
		overlay.addEventListener("click", () => {
			const videoPlayer = thisSection.querySelector(".video-player");
			if (videoPlayer) {
				thisSection.classList.add("video-playing");
				if (videoPlayer.classList.contains("html5-player")) {
					videoPlayer.play();
				} else {
					const thisPlayer = players[videoPlayer.id];
					if (videoPlayer.classList.contains("youtube-player")) {
						thisPlayer.playVideo();
					} else {
						thisPlayer.play();
					}
				}
			}
		});
	});
});
